import {MutableMessageTemplate, template as tpl} from "./mutable";
import {IMessage, IRouteDefinitionParams} from "../../index";
import {ObjectTypeId, SMS_ABSOLUTE_LIMIT, SMS_LIMIT} from "../../constants";
import PromiseRequest from "../../req/PromiseRequest";
import {_} from 'lodash';
import {global} from "../../appContext";
import {nsMessages} from "./fn";

export let template: string = tpl;

export class viewModel extends MutableMessageTemplate {

    protected readonly submitSuccessMessage: string = `subject is updated|s:((messageflow))`

    private readonly req_getmessage: PromiseRequest = global.getPromiseRequest("getmessage")
    protected readonly req_submit: PromiseRequest = global.getPromiseRequest("updatemessage")

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.kosub.subscribe(this.objecttypeid, (id: ObjectTypeId | null) => {
            if (id != null && id != ObjectTypeId.FormData) {
                this.initSyncStep();
                if (!this.data.syncstep() && !global.pv.superAdmin()) {
                    super.initSyncStep();
                }
            }
        })
        this.init();
    }

    protected override init(): Promise<void> {
        return super.init()
            .then(() => {
                return this.__requestRouteData!
                    .request()
                    .then((data: IMessage[]) => {
                        this.data.$original = _.cloneDeep(data[0]);
                        const d: IMessage = _.cloneDeep(data[0]);
                        this.data.active(d.active);
                        const addrecipient = d.addrecipient ? nsMessages.splitRecipients(d.addrecipient).map(str => str.trim()).join(',') : '';
                        this.data.addrecipient(addrecipient);
                        this.data.body(d.body);
                        this.data.description(d.description);
                        this.data.messagetype(d.messagetype);
                        this.data.name(d.name);
                        this.data.recipientfield(d.recipientfield);
                        this.data.sender(d.sender);
                        this.data.subject(d.subject);
                    })
            })
            .then(() => this.initMessageType())
            .then(() => this.initSyncStep())
            .then(() => {
                if (this.data.body().length > SMS_LIMIT) {
                    this.currentLimit(SMS_ABSOLUTE_LIMIT);
                }
            })
            .then(this.initAfter.bind(this))
            .catch(this.initError.bind(this));
    }

    protected override initSyncStep() {
        const syncstep = this.companySyncsteps
            .map(companySyncstep => companySyncstep.syncstep)
            .find(syncstep => syncstep.id == this.data.$original.syncstepid)
        ;
        this.data.syncstep(syncstep ?? null);
    }

    override dispose() {
        super.dispose();
        this.req_getmessage?.abort?.()
    }

}
